
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/video-tools",
      function () {
        return require("private-next-pages/video-tools.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/video-tools"])
      });
    }
  